import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogActions, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { AuthService } from 'src/app/auth/auth.service';
import { SystemAlertService } from 'src/app/external-user/inventory/services/system-alert.service';
import { SystemAlertDto } from '../../models/system-alert-dto';
import { ToastService } from 'src/app/shared/services/toast.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatTable, MatTableModule } from '@angular/material/table';
import { SystemAlert } from '../../models/system-alert';
import { SystemAlertAck } from '../../models/system-alert-ack';
import { User } from 'src/app/common/user/models/user';
import { CreateAckDialogComponent } from '../create-ack-dialog/create-ack-dialog.component';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'system-alerts-dialog',
    templateUrl: './system-alerts-dialog.component.html',
    styleUrls: ['./system-alerts-dialog.component.scss'],
    imports: [ FormsModule, MatTableModule, MatTooltipModule, MatDialogActions, MatDialogTitle ],
    standalone: true
})
export class SystemAlertsDialogComponent implements OnInit {
  @ViewChild(MatTable) table: MatTable<SystemAlertDto>;
  
  public isSystemAlertingEnabled: boolean = false;

  public systems: SystemAlertDto[] = [];

  public displayedColumns = ['id', 'alert', 'ack', 'edit'];

  constructor(
    public dialogRef: MatDialogRef<SystemAlertsDialogComponent>,
    public dialog: MatDialog,
    public auth: AuthService,
    public systemAlertService: SystemAlertService,
    private readonly toastService: ToastService,
    private readonly ngxLoader: NgxUiLoaderService
  ) { }

  ngOnInit() {
    this.auth.profile$.subscribe(profile => {
      this.isSystemAlertingEnabled = profile.hasSystemAlertingAccess();
      if (this.isSystemAlertingEnabled) { this.refreshSystemAlerts(); }
    });
  }

  refreshSystemAlerts()
  {
    const loadingKey = 'loadAlertsTopLevel';
    this.ngxLoader.start(loadingKey);
    this.systemAlertService.getAlertsTopLevel().subscribe({
      next: (value) => {
        this.systems = value;
        this.ngxLoader.stop(loadingKey);
      }, 
      error: (error) => { 
        this.toastService.stopLoadingAndShowError("Unable to load alerts:", error.message); 
        this.ngxLoader.stop(loadingKey);
      }
    });
  }

  onDoneClicked(): void { this.dialogRef.close(); }

  getAlertTooltip(alert: SystemAlert) {
    return `Description: ${alert.systemAlertType.description}\r\n`
      + `Timestamp: ${alert.timestamp}`;
  }

  getAckTooltip(ack: SystemAlertAck) {
    let provider: User = ack.user;
    return `Description: ${ack.systemAlertAckType.description}\r\n`
      + `Provider: ${provider.firstName} ${provider.lastName}\r\n`
      + `Ack Details: ${ack.description}\r\n`
      + `Timestamp: ${ack.timestamp}`;
  }

  onEdit(alert: SystemAlert): void {
    let ackDialog = this.dialog.open(
      CreateAckDialogComponent,
      { disableClose: false, backdropClass: ['notificationsDialog','lgDialog', 'SnackDialog'] }
    );
    ackDialog.componentInstance.alert = alert;

    
    ackDialog.afterClosed().subscribe((changeMade: boolean) => {
      if (changeMade) { this.refreshSystemAlerts(); }
    });
  }

  isResolved(ack: SystemAlertAck) {
    return ack.systemAlertAckType.name.toLowerCase() == 'resolved';
  }
}
